import { GenerateStyle } from '../generateStyle';

import deep_canvassing from './deep_canvassing';
import glapp from './glapp';
import pvda from './pvda';

export default {
  'deep_canvassing': deep_canvassing,
  'glapp': glapp,
  'pvda': pvda,
} as Record<string, GenerateStyle>;
